import Vue from "vue";
import App from "./App.vue";
import "video.js/dist/video-js.css";
import Toasted from 'vue-toasted';
import { store } from "@/store/store";

import "bootstrap/scss/bootstrap-reboot.scss";
import "bootstrap/scss/bootstrap-grid.scss";

const css = [
  process.env.VUE_APP_FS1_CDN_URL_PREFIX+"/site/css/iconfont2/iconfont.css?v=2",
];
css.forEach(i => {
  loadCss(i);
});

Vue.config.productionTip = false;

window.HELP_IMPROVE_VIDEOJS = false;
// export function showErrorAndReport( err, vm, info) {
//   console.log(err, vm, info);
// }

import VueClipboard from 'vue-clipboard2'
import {formatDuration, loadCss} from '@/common/utils.js';

if (process.env.NODE_ENV === 'production'){
  console.log = ()=>{}
  console.error = ()=>{}
  console.warn = ()=>{}

  window.onunhandledrejection = event => {
    event.preventDefault();
  };
}

window.onerror = event => {
  console.log(event);
}

Vue.use(VueClipboard)
Vue.use(Toasted)
Vue.filter('formatDuration',formatDuration);

import VueSocialSharing from 'vue-social-sharing';
Vue.use(VueSocialSharing);
new Vue({
  render: h => h(App),
  store
}).$mount("#app");
